// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1G6lL","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3HJPf"};